import { gql } from '@apollo/client'

import { DISH_LIST_FRAGMENT } from '../fragments'

const UPDATE_DISH_MUTATION = gql`
  mutation updateDish($id: ID!, $data: DishUpdateInput!) {
    updateDish(id: $id, data: $data) {
      ...DishListFragment
    }
  }
  ${DISH_LIST_FRAGMENT}
`

export default UPDATE_DISH_MUTATION
